import { AttributeType } from "../../../clients/Purchaser/Attributes";
import { Input, stopKeyPropagation } from "../../DesignSystem";
import type { AddressAttributeFilter, SetAttributeFilter } from "../types";
import SetFilterItems from "./SetFilterItems";
import { useContainsSearch } from "./useContainsSearch";

type AddressAttributeFilterSubmenuProps = {
    attributeId: number;
    currentFilter?: AddressAttributeFilter;
    setAttributeFilter: SetAttributeFilter;
};

function AddressAttributeFilterSubmenu({ attributeId, currentFilter, setAttributeFilter }: AddressAttributeFilterSubmenuProps) {
    // "Contains" query. The backend does the fuzzy substring match on the formatted address.
    const [search, setSearch] = useContainsSearch({ type: AttributeType.ADDRESS, attributeId, currentValue: currentFilter?.value, setAttributeFilter });

    return (
        <>
            <Input
                placeholder="Enter an address"
                value={search}
                autoFocus
                onChange={e => setSearch(e.target.value)}
                inputContainerClasses="mb-1 w-full"
                className="w-full"
                onKeyDown={stopKeyPropagation}
            />
            {/* Picking a set/not-set option replaces any contains query. */}
            <SetFilterItems
                type={AttributeType.ADDRESS}
                attributeId={attributeId}
                currentSet={currentFilter?.set}
                setAttributeFilter={setAttributeFilter}
                onPick={() => setSearch("")}
            />
        </>
    );
}

export default AddressAttributeFilterSubmenu;
